import React, {
  useRef,
} from 'react';

import {
  useScroll,
} from 'web-hooks';

import * as S from './styled';

type Props = {
  header: React.ReactNode,
  /**
   * Contents to render
   */
  children: React.ReactNode,
};

const ContentWrapper = ({
  header,
  children,
}: Props) => {
  const target = useRef<HTMLDivElement>(null);
  const scroll = useScroll(target);

  return (
    <S.Wrapper>
      {header && <S.Header sticky={scroll.top > 0}>{header}</S.Header>}
      <S.Body ref={target} id="sticky_header">
        {children}
      </S.Body>
    </S.Wrapper>
  );
};

export default ContentWrapper;
